import type { ISEOProps } from "../types/core";

export const DashboardPageSEO: ISEOProps = {
  title: "Creator Dashboard - Sugar Cribs",
  description:
    "Manage your creator account on Sugar Cribs. View analytics, earnings, and performance metrics.",
};
